<template>

    <div class="settings__item data-card block">
        <div class="data-card__head">
            <div class="data-card__title">Пароль</div>
            <div class="data-card__link">
                <a href="#dataCard_9" 
                   class="link link--present" 
                   data-toggle="collapse"
                   v-on:click='serverMessage = []'
                ><span class="link__text">Изменить</span></a>
            </div>
        </div>
        <div id="dataCard_9" class="data-card__form accordion-body collapse">
            <div class="data-card__inner accordion-body__inner">
                <div class="b-form-sm">
                    <div class="b-form-sm__body">

                        <div class="b-form-sm__item">
                            <label class="txt-input txt-input--tip">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input is-filled"
                                           v-model="currentPassword"
                                           type="password"
                                           placeholder="Введите текущий пароль">
                                    <div class="txt-input__ctrl">
                                        <div class="button-icon js-show-password"><i class="icon icon--view"></i></div>
                                    </div>
                                </div>
                            </label>
                        </div>

                        <div class="b-form-sm__item">
                            <label class="txt-input">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input is-filled"
                                           :class="$v.newPassword.$invalid && currentPassword != '' ? 'is-error' : ''"
                                           :disabled="$v.currentPassword.$invalid"
                                           v-model="newPassword"
                                           type="password"
                                           placeholder="Новый пароль">
                                    <div class="txt-input__ctrl">
                                        <div class="button-icon js-show-password"><i class="icon icon--view"></i></div>
                                    </div>
                                </div>
                            </label>
                        </div>

                        <div class="b-form-sm__item">
                            <label class="txt-input">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input is-filled"
                                           :class="!this.$v.confirmedPassword.sameAsconfirmedPassword && !this.$v.newPassword.$invalid ? 'is-error' : ''"
                                           :disabled="$v.currentPassword.$invalid || $v.newPassword.$invalid"
                                           v-model="confirmedPassword"
                                           type="password"
                                           placeholder="Повторите новый пароль">
                                    <div class="txt-input__ctrl">
                                        <div class="button-icon js-show-password"><i class="icon icon--view"></i></div>
                                    </div>
                                </div>
                            </label>
                        </div>

                        <div class="b-form-sm__item">
                            <a class="button button--th-second"
                               :class="!isConfirmedPassword ? 'disabled' : ''"
                               data-drop-toggle="modalPhoneSubmit"
                               v-on:click='changePassword'>Сохранить</a>
                            <a href="#dataCard_9" class="button button--th-link" data-toggle="collapse">Отменить</a>
                        </div>

                        <div class="data-card__caption validated-block">
                            Для защиты ваших данных необходимо придумать безопасный пароль. Он должен содержать:
                        </div>

                        <div class="validate-errors-block">
                            <span class="error-msg"
                                  :class="!$v.newPassword.minLength || newPassword == '' ? 'error-block' : 'validated-block'">{{$v.newPassword.$params.minLength.min}} и более символов</span>
                            <span class="error-msg"
                                  :class="!$v.newPassword.mustOneMoreUpperCase ? 'error-block' : 'validated-block'">Прописные буквы [A-Z][А-Я]</span>
                            <span class="error-msg"
                                  :class="!$v.newPassword.mustOneMoreLowerCase ? 'error-block' : 'validated-block'">Строчные буквы [a-z][а-я]</span>
                            <span class="error-msg"
                                  :class="!$v.newPassword.mustOneMoreSpecialCharacter ? 'error-block' : 'validated-block'">Специальные символы [!@#$%^&*()_+.]</span>
                            <span class="error-msg"
                                  :class="!$v.newPassword.mustOneMoreDigit ? 'error-block' : 'validated-block'">Цифры</span>

                            <span class="txt-input__required txt-input__required--error error-block">{{validatePasswordTypeText}}</span>

                            <span class="txt-input__required" :class="isValidateErrors ? 'error-block' : 'validated-block'">{{serverResponseText}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    const { required, minLength, sameAs } = window.validators
    const { validationMixin, Vuelidate } = window.vuelidate

    export default {
        mixins: [validationMixin],
        props: ['user'],
        data: function () {
            return {
                currentPassword: '',
                newPassword: '',
                confirmedPassword: '',
                isValidateErrors: false,
                serverMessage: [],
                serverResponse: ''
            }
        },
        created: function () {
        },
        computed: {
            isConfirmedPassword: function () {
                return (this.$v.confirmedPassword.$model !== '' && !this.$v.confirmedPassword.$invalid) ? true : false; 
            },
            validatePasswordTypeText: function () {
                if (!this.$v.newPassword.different)
                    return 'Новый пароль должен отличаться от текущего';

                if (!this.$v.confirmedPassword.sameAsconfirmedPassword && !this.$v.newPassword.$invalid)
                    return 'Пароли должны совпадать';

                return '';
            },
            serverResponseText: function () {
                return this.serverMessage ? this.serverMessage[0] : '';
            }
        },
        watch: {
            currentPassword: function () {
                if (this.currentPassword == '') {
                    this.clearInputs();
                }
                if (this.currentPassword.length >= 1) {
                    this.serverMessage = [];
                }
            },
            isValidateErrors: function (isValidateErrors) {
                if (!isValidateErrors) {
                    this.serverMessage = [];
                }
            },
            serverResponse: function (serverResponse) {
                this.serverMessage = serverResponse.message;

                if (serverResponse.isSuccess) {
                    this.isValidateErrors = false;
                    this.clearInputs();
                } else {
                    this.isValidateErrors = true;
                    this.clearInputs();
                }
            }
        },
        validations: {
            currentPassword: {
                required: required,
            },
            newPassword: {
                required: required,
                minLength: minLength(8),
                different: function (value) {
                    if (!value) {
                        return true;
                    }

                    return value !== this.currentPassword
                },
                mustOneMoreUpperCase: function (value) {
                    return value.match('[A-ZА-Я]+') ? true : false;
                },
                mustOneMoreLowerCase: function (value) {
                    return value.match('[a-zа-я]+') ? true : false;
                },
                mustOneMoreSpecialCharacter: function (value) {
                    return value.match('[!@#$%^&*()_+.]+') ? true : false;
                },
                mustOneMoreDigit: function (value) {
                    return value.match('[0-9]+') ? true : false;
                }
            },
            confirmedPassword: {
                sameAsconfirmedPassword: sameAs('newPassword')
            },
        },
        methods: {
            clearInputs: function () {
                this.currentPassword = this.newPassword = this.confirmedPassword = '';
            },
            changePassword: function () {
                var self = this;
                this.isValidateErrors = false;

                axios.post('/Profiles/ChangePassword', {
                    CurrentUserName: this.user.UserName,
                    CurrentPassword: this.currentPassword,
                    NewPassword: this.newPassword,
                    ConfirmPassword: this.confirmedPassword
                })
                    .then(function (response) {
                        self.serverResponse = response.data;
                        document.querySelector('html').classList.remove('is-lock');
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.clearInputs();
                        self.serverMessage = ['Изменение пароля невозможно, попробуйте позже']
                    });
            }
        }
    }

</script>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/ChangePassword.vue